import { Directive, ElementRef, OnInit } from '@angular/core';
import { style } from '../../utils/style.utils';

@Directive({
  selector: '[sag-ui-avatar-base]',
})
export class AvatarBaseDirective implements OnInit {
  constructor(private readonly elementRef: ElementRef<HTMLSpanElement>) {}

  ngOnInit(): void {
    style(this.elementRef, 'flex flex-row items-center justify-start gap-2.5');
  }
}
